import { InjectionToken } from '@angular/core';
import type { LocalStorageKey } from '../services/local-storage-keys';
import { LOCAL_STORAGE_KEYS } from '../services/local-storage-keys';

/**
 * Injection token for the localStorage key used to persist the companion code.
 * Provide a key from {@link LOCAL_STORAGE_KEYS.companion} (e.g. chemicalsCode)
 * so multiple companion apps on the same device don't share state.
 */
export const COMPANION_CODE_STORAGE_KEY = new InjectionToken<LocalStorageKey>(
	'COMPANION_CODE_STORAGE_KEY',
	{
		providedIn: 'root',
		factory: () => LOCAL_STORAGE_KEYS.companion.code,
	},
);
